import { render, staticRenderFns } from "./Groups.html?vue&type=template&id=bda7b814&external"
import script from "./Groups.js?vue&type=script&lang=js&external"
export * from "./Groups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports